import { setToken } from "@/setup/api";

export default {
  login(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/accounts/signin", data)
        .then(function (response) {
          setToken(response.data.token);
          context.commit("setUser", response.data);
          context.commit("setLogged", true);

          resolve(response);
        })
        .catch(reject);
    });
  },

  addToUnfinishedVideos(context, data) {
    const unfinishedVideos = context.state.user.unfinished_videos;
    const notInsideList = !unfinishedVideos.filter((c) => c.id == data.id)
      .length;

    if (notInsideList) {
      return new Promise((resolve, reject) => {
        window.axios
          .post("/user/course-list", data)
          .then(function (response) {
            context.commit("pushToUnfinishedVideos", response.data);
            resolve();
          })
          .catch(reject);
        context.commit("pushToUnfinishedVideos", data);
      });
    }
  },

  register(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/accounts/create", data)
        .then(function (response) {
          setToken(response.data.token);
          context.dispatch("postLogin", null, { root: true });
          resolve();
        })
        .catch(reject);
    });
  },

  forgot(context, data) {
    return new Promise((resolve, reject) => {
      window.axios.post("/accounts/forgot", data).then(resolve).catch(reject);
    });
  },

  resetPassword(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/accounts/reset-password", data)
        .then(resolve)
        .catch(reject);
    });
  },

  getMessages(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/students/messages")
        .then(function (response) {
          context.commit("setMessages", response.data);
          resolve(response.data);
        })
        .catch(reject);
    });
  },

  get(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/accounts/")
        .then((response) => {
          context.commit("setUser", response.data);
          // context.commit("setUser", userPlaceholderData);
          resolve();
        })
        .catch(reject);
    });
  },

  update(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .put("/accounts/update", data)
        .then(function () {
          context.commit("updateUser", data);
          resolve();
        })
        .catch(reject);
    });
  },

  updatePassword(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .put("/accounts/change-password", data)
        .then(resolve)
        .catch(reject);
    });
  },

  registration_asks(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/registrations")
        .then(({ data }) => resolve(data))
        .catch(reject);
    });
  },

  answer_registrations_ask(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .post(`/registrations/add-registrationuser`, data)
        .then(resolve)
        .catch(reject);
    });
  },
};
